import BaseApiClient from '../BaseApiClient';
import { EmployeeSizeInterface } from '@interfaces/EmployeeSize.interface';

export class ApiEmployeeSize extends BaseApiClient {
  /**
   * Get all items
   */
  async all(): Promise<Array<EmployeeSizeInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/employee-size?page[size]=999')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { employeeSizeQueryKeys } from './query-keys';
export { useEmployeeSizeAllQuery } from './use-employee-size-queries';
